export default "__VITE_ASSET__DDsJLC9G__"